import { css } from 'styled-components';
import { StyledTheme } from '../../../../styles';

export const AuthenticationResetBaseStyles = css<{ theme: StyledTheme }>``;
